module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown-menu', _vm._b({}, 'el-dropdown-menu', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9796a09e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dropdown/rtDropdownMenu.vue
// module id = 1462
// module chunks = 116